export default __webpack_public_path__ + "static/inbox-messages_sent-93ca1794f4d654dd7625b3ea562e7100.svg";